function createEntity(options = {}) {
    options.namespaced = options.namespaced || true;

    const state = {
        items: []
    };

    const mutations = {
        load(state, items) {
            state.items = items;
        },

        add(state, items) {
            if (!Array.isArray(items)) {
                items = [items];
            }

            state.items = state.items.concat(items);
        },

        update(state, changes) {
            let item = state.items.find(item => item.id == changes.id);
            Object.assign(item, changes);
        },

        delete(state, ids) {
            if (!Array.isArray(ids)) {
                ids = [ids];
            }

            state.items = state.items.filter(item => !ids.includes(item.id));
        },
        deleteByEmail(state, emails) {
            if (!Array.isArray(emails)) {
                emails = [emails];
            }
            state.items = state.items.filter(item => !emails.includes(item.email));
        }
    };

    const getters = {
        first: (state) => () => {
            return state.items[0];
        },

        getAll() {
            return state.items;
        },

        getById: (state) => (id) => {
            return state.items.find(item => item.id == id);
        },

        query: (state) => (fn) => {
            return state.items.filter(fn);
        }
    };

    return {
        namespaced: options.namespaced,
        state,
        getters,
        mutations
    }
}

export default createEntity;